/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ConditionDTO,
    ConditionDTOFromJSON,
    ConditionDTOFromJSONTyped,
    ConditionDTOToJSON,
} from './ConditionDTO';

/**
 * 
 * @export
 * @interface ActionNodeDTO
 */
export interface ActionNodeDTO {
    /**
     * 
     * @type {string}
     * @memberof ActionNodeDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionNodeDTO
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ActionNodeDTO
     */
    informIfMissing?: boolean;
    /**
     * 
     * @type {Array<ConditionDTO>}
     * @memberof ActionNodeDTO
     */
    conditions?: Array<ConditionDTO>;
}

export function ActionNodeDTOFromJSON(json: any): ActionNodeDTO {
    return ActionNodeDTOFromJSONTyped(json, false);
}

export function ActionNodeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActionNodeDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'informIfMissing': !exists(json, 'informIfMissing') ? undefined : json['informIfMissing'],
        'conditions': !exists(json, 'conditions') ? undefined : ((json['conditions'] as Array<any>).map(ConditionDTOFromJSON)),
    };
}

export function ActionNodeDTOToJSON(value?: ActionNodeDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'informIfMissing': value.informIfMissing,
        'conditions': value.conditions === undefined ? undefined : ((value.conditions as Array<any>).map(ConditionDTOToJSON)),
    };
}

